import VideoPlayer from '../VideoPlayer';
import CardContainer from '../CardContainer';

import LevelProgress from './LevelProgress';
import StatusTitle from './StatusTitle';

interface StatusCardProps {
  id: string | undefined;
  title: string;
  level: number;
  videoSrc: string;
  totalPoints: number;
  maxPoints: number;
}

const StatusCard: React.FC<StatusCardProps> = ({ id, title, level, videoSrc, totalPoints, maxPoints }: StatusCardProps) => {
  const remainingPoints = maxPoints - totalPoints;

  return (
    <CardContainer>
      <StatusTitle id={id} title='Your status' />
      <div className='flex-1 overflow-hidden'>
        <VideoPlayer src={videoSrc} className='w-full h-full object-contain' />
      </div>
      <div className='flex flex-col gap-1 p-8'>
        <p className='text-2xl lg:text-[32px] font-bold text-text-primary text-center leading-none'>{title}</p>
        <p className='text-lg lg:text-2xl font-medium text-text-primary text-center leading-none'>Level {level}</p>
      </div>
      <LevelProgress totalPoints={totalPoints} remainingPoints={remainingPoints} maxPoints={maxPoints} />
    </CardContainer>
  );
};

export default StatusCard;
